export default "__VITE_ASSET___RkJU8jR__"